import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft } from "@fortawesome/free-solid-svg-icons";

export default function TestimonailsSlider (){

    var settings = {
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1100,
                settings: { slidesToShow: 2, slidesToScroll: 1 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1, slidesToScroll: 1 }
            }
        ]
    };

    return(
        <div className="testimonailslider-wrapper">
            <Slider {...settings}>
                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>As a founder, I'm constantly switching between product, sales, hiring, and investor conversations. I don't have hours to design presentations from scratch. SlideEZ-AI helped me turn our business updates into a clear, professional deck using ready-made infographic layouts, which saved me a lot of time.</p>
                    <h3>— Emily Carter</h3>
                    <h4>Founder | SaaS Technology</h4>
                </div>

                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>My co-founder and I had all the information ready for our investor pitch, but the slides were too text heavy. SlideEZ-AI helped us shorten the content and find layouts that explained our business model and growth plans more visually. It made our story much easier to present.</p>
                    <h3>— Omar Al Mansoori</h3>
                    <h4>Co-founder | Logistics Technology</h4>
                </div>

                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>For one of our MBA group projects, we had plenty of research but no clear idea how to present it. SlideEZ-AI helped us organize the findings, analysis, and recommendations into suitable infographic layouts. We spent less time formatting and more time preparing for the actual presentation.</p>
                    <h3>— Rohan Mehta</h3>
                    <h4>MBA Student | Finance and Strategy</h4>
                </div>

                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>I prepare monthly performance updates for our leadership team, and the challenge is always presenting a lot of information without overcrowding the slides. SlideEZ-AI helped me structure the key messages into clean infographic layouts, making the presentation easier for senior management to review.</p>
                    <h3>— Charlotte Bennett</h3>
                    <h4>Strategy Manager | Corporate Strategy</h4>
                </div>

                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>While working on a client pitch, I needed to present the company profile, transaction process, and investment highlights under a tight deadline. SlideEZ-AI gave me a strong starting point with relevant layouts that I could edit directly in PowerPoint. It helped me complete the slides much faster.</p>
                    <h3>— Daniel Tan</h3>
                    <h4>Analyst | Investment Banking</h4>
                </div>

                <div className="testimonailslide-child">
                    <FontAwesomeIcon icon={faQuoteLeft} />
                    <p>My research presentations usually include market trends, company comparisons, and detailed findings. SlideEZ-AI helps me convert that information into cleaner visual stories instead of filling slides with text. The layouts are editable, so I can adapt them to our report format and branding.</p>
                    <h3>— Aisha Rahman</h3>
                    <h4>Senior Analyst | Investment Research</h4>
                </div>
            </Slider>
        </div>
    )
}